export const ADMIN_LAYOUT_MODES = Object.freeze({
  VERTICAL: 'vertical',
  HORIZONTAL: 'horizontal',
});

/**
 * Cloud/standalone keeps the full left navigation. Embedded and explicitly
 * compact surfaces use the horizontal shell, independently of API runtime.
 */
export function resolveAdminLayoutMode({ isCompactMode, isEmbedded }) {
  return isCompactMode || isEmbedded
    ? ADMIN_LAYOUT_MODES.HORIZONTAL
    : ADMIN_LAYOUT_MODES.VERTICAL;
}
